/**
 * One listing in a collection grid: product thumbnail, name, and price.
 * Uses productImageUrls for the thumbnail so it follows the same media
 * resolution path as the rest of the product card family.
 */

import React, { useState } from "react";
import { ProductDetailsModal } from "../../../../interfaces/ProductObject";
import { productImageUrls } from "../../../../services/helpers/ProductImageHelper";
import { Assets } from "../../../../constants/Assets";

interface CollectionProductCardProps {
  product: ProductDetailsModal;
  onOpen: (product: ProductDetailsModal) => void;
}

const CollectionProductCard: React.FC<CollectionProductCardProps> = ({
  product,
  onOpen,
}) => {
  const [imgError, setImgError] = useState(false);
  const urls = productImageUrls(product);
  const thumbUrl = urls[0];
  const showImg = Boolean(thumbUrl) && !imgError;

  const price =
    product.displayPrice &&
    typeof product.sellingPrice === "number" &&
    product.sellingPrice > 0
      ? `₹${product.sellingPrice.toLocaleString()}`
      : null;

  return (
    <button
      type="button"
      className="coll-card"
      aria-label={product.title}
      onClick={() => onOpen(product)}
    >
      <span className="coll-card-logo">
        {showImg ? (
          <img
            src={thumbUrl}
            alt=""
            loading="lazy"
            onError={() => setImgError(true)}
          />
        ) : (
          <img
            src={Assets.PLACEHOLDERS.PRODUCT_IMAGE}
            alt=""
          />
        )}
      </span>

      <span className="coll-card-name">
        {product.title?.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase())}
      </span>

      {price && (
        <span className="coll-card-bottom">
          <span className="coll-card-tag">{price}</span>
        </span>
      )}
    </button>
  );
};

export default CollectionProductCard;
